import Button from '@material-ui/core/Button';
import * as lib from '~/dependencies';
import { colors, fonts, margins } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${colors.white};
  overflow: scroll;
  position: relative;

  &::-webkit-scrollbar { width: 0!important; height: 0!important; }
  overflow: -moz-scrollbars-none!important; }
  -ms-overflow-style: none!important; }

  #box-avatar {
    position: relative;
    align-items: flex-end;
    justify-content: center;
    display: flex;
    padding-top: 60px;

    .avatar {
      position: absolute;
      top: -60px;
      width: 100px;
      height: 100px;
      border: 4px solid ${colors.white};
      background-color: ${colors.lightGray10};

      span {
        font-size: 28px;
        color: ${colors.black};
        opacity: 0.2;
      }
    }
    .title {
      font-size: 16px;
      color: ${colors.black};
    }
  }
`;

export const BackButton = lib.styled.a`
  color: ${colors.black};
  opacity: 0.5;
  font-size: ${fonts.default}px;
  font-weight: 800;
  margin-right: 10px;
  cursor: pointer;
`;

export const BoxBtn = lib.styled.div`
  width: 26px;
  height: 26px;
  background-color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 15px;

  .icon {
    font-size: 15px;
    color: ${colors.darkBlue02};

    div {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const BoxInformations = lib.styled.div`
  display: flex;
  border: 1px dotted ${colors.lightGray06};
  border-radius: 10px;
  background-color: ${colors.white02};
  margin-top: 30px;
  margin: ${margins.default}px!important;

  flex-direction: column;

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    padding: 5px 15px 5px 15px;
    border-bottom: 1px dotted ${colors.lightGray06};

    &:last-child {
      border-bottom: 0;
    }

    .left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;

      span:first-child {
        font-size: ${fonts.label}px;
        color: ${colors.black};
        opacity: 0.5;
      }
      span:last-child {
        font-size: ${fonts.default}px;
        color: ${colors.black};
      }
    }

    .right {
      button {
        padding: 0px!important;
        min-width: 40px!important;
        height: 40px!important;
        display: flex;
        align-items: center;
        justify-content: center;

        .call-icon {
          width: 26px!important;
          height: 26px!important;
        }
      }
    }

    .icon-sms {
      display: flex;
      position: absolute;
      right: 65px;
      justify-content: center;
      align-items: center;
      width: 26px;
      height: 27px;
      background-color: ${colors.green05}
      border-radius: 50px;
      margin-right: 10px;
      &:hover {
        background-color: ${colors.green05}
      }
    }

    .icon-sms-svg {
      width: 18px;
      height: 16px;
      color: ${colors.white}
    }
  }
`;

export const DisplayTop = lib.styled.div`
  background: linear-gradient(52.71deg, #00AFF0 2.79%, #0C4BBC 73.37%);
  height: 77px;
  min-height: 77px;
  max-height: 77px;
  display: flex;
  flex: 1;
`;

export const BoxData = lib.styled.div`
  display: flex;
  flex: 1;
  max-height: 50px;
  align-items: center;
  justify-content: center;
`;

export const BoxActions = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonField = lib.styled(Button)`
  border-radius: 50%!important;
  min-width: 5px!important;
`;

export const Chip = lib.styled.div`
  display: flex;
  flex-direction: row;
  font-size: 13px!important;
  flex-wrap: wrap;
  margin-left: -4px;

  span {
    font-size: 13px!important;
    background-color: #84818117;
    border: 1px #FFF;
    border-radius: 12px;
    margin: 2px;
    padding: 6px;
    color: #5d5c5c!important;
    opacity: 1!important;
  }

  span:first-child {
    margin-right: 3px;
  }
  span:last-child {
    margin-left: 3px;
  }
`;
